import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const InvestorLenderReporting = () => {
  const serviceData = {
    title: "Investor & Lender Reporting",
    heading: "Investor & Lender Reporting",
    image: subTopicImages["Investor & Lender Reporting"],
    intro:
      "Professional, credible and timely reporting for capital raising and relationship management.",
    description: [
      "Raising capital or managing lender relationships requires professional, credible and timely reporting. We strengthen confidence with investors, lenders and strategic partners through structured reporting frameworks.",
    ],
    services: [
      {
        title: "Reporting & Communication",
        text: "We assist with:",
        list: [
          "investor reporting & financial narratives",
          "covenant monitoring and reporting",
          "lender updates & compliance reporting",
          "financial communication frameworks",
        ],
        extraInfo:
          "This strengthens confidence with investors, lenders and strategic partners.",
      },
    ],
    benefitsIntro: "Outcomes:",
    benefits: [
      "Professional investor communications",
      "Strict compliance with loan covenants",
      "Enhanced credibility with financial partners",
      "Transparent financial narratives",
    ],
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default InvestorLenderReporting;
